import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito'
import { sessionStorage } from '@aws-amplify/core'
import { env } from '@/lib/env'

export function configureAuth(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: env.VITE_COGNITO_CLIENT_ID,
      },
    },
  })

  // Use sessionStorage instead of localStorage for token persistence.
  // Tokens clear on tab close, avoiding localStorage per CLAUDE.md security rules.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage)
}
